import React, { FC } from "react";
import { darken, lighten, Typography, useTheme } from "@mui/material";
import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey,
} from "@mui/material/colors";

const stringToIndex = (name: string, length: number) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % length;
};

const baseColors = [
  red[500],
  pink[500],
  purple[500],
  deepPurple[500],
  indigo[500],
  blue[500],
  lightBlue[500],
  cyan[500],
  teal[500],
  green[500],
  lightGreen[500],
  lime[500],
  yellow[700],
  amber[500],
  orange[500],
  deepOrange[500],
  brown[500],
  grey[600],
  blueGrey[500],
];

export const ChatUserName: FC<{ name: string }> = ({ name }) => {
  const theme = useTheme();
  const index = stringToIndex(name, baseColors.length);
  const baseColor = baseColors[index];
  const color =
    theme.palette.mode === "dark"
      ? lighten(baseColor, 0.3)
      : darken(baseColor, 0.2);
  return (
    <Typography variant="subtitle2" sx={{ color }}>
      {name}
    </Typography>
  );
};
